import View360, { EquirectProjection } from "@egjs/react-view360";
import React, { useMemo } from "react";
import styled from "styled-components";

interface viewer360Props{
    url: string;
    isFullscreen?: boolean;
}

const Viewer360 = React.forwardRef<HTMLDivElement, viewer360Props>((p, ref) => {

    const projection = useMemo(() => new EquirectProjection({
        src : p.url
    }), [p.url]);

    return (
        <Container ref={ref} $isFullscreen={!!p.isFullscreen}>
            <View360
                className="is-16by9"
                projection={projection}
            />
        </Container>
    )
});

Viewer360.displayName = "Viewer360";

const Container = styled.div<{ $isFullscreen: boolean }>`
    position: relative;
    user-select: none;

    width: ${({ $isFullscreen }) => $isFullscreen ? '100vw' : 'calc(min(80vh / 9 * 16, 80vw) * 0.8)'};
    height: ${({ $isFullscreen }) => $isFullscreen ? '100vh' : 'calc(min(80vh, 80vw / 16 * 9) * 0.8)'};

    /* Example: adjust sizing on smaller screens */
    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        width: ${({ $isFullscreen }) => $isFullscreen ? '100vw' : 'calc(min(95vh / 9 * 16, 95vw) * 0.8)'};
        height: ${({ $isFullscreen }) => $isFullscreen ? '100vh' : 'calc(min(95vh, 95vw / 16 * 9) * 0.8)'};
    }

    & canvas {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }

    & .view360-container {
        width: 100%;
        height: 100%;
    }
`
export default Viewer360